import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import TooltipIcon from '../../TooltipIcon';

const computeRate = (num, den) => (parseFloat(den ? (num / den * 100).toFixed(1) : 0));

const SurveySentStatsWidget = ({data}) =>
    (
        <div className="d-flex flex-column justify-content-around survey-stats-widget">
            <div className="d-flex stats-container">
                <div className="stats-label"><FormattedMessage {...messages.dashboard.stats.sent} /></div>
                <div className="stats-value">{data.sent || 0}</div>
            </div>
            <div className="d-flex stats-container">
                <div className="stats-label"><FormattedMessage {...messages.dashboard.stats.sentCompleted} /></div>
                <div className="stats-value">{data.sentCompleted || 0}</div>
            </div>
            <div className="rates-container">
                <div className="rates-label">
                    <FormattedMessage {...messages.dashboard.stats.response} />
                    {' '}
                    <TooltipIcon message={messages.dashboard.stats.tooltip.response} />
                </div>
                <div className="rates-value">{computeRate(data.sentCompleted || 0, data.sent || 0)}%</div>
            </div>
        </div>
    );

export default SurveySentStatsWidget;
